import React, { FC } from 'react';
import styled from 'styled-components';
import Grow from 'components/UI/Grow';
import LoginInput from 'components/pages/Login/LoginInput';
import AuthHeader from 'components/pages/Login/AuthHeader';
import SmsInput from 'components/pages/Login/SmsInput';

const Page = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

const LoginContainer = styled.div`
  display: flex;
  flex: 3;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
`;

const Login: FC = () => {
  return (
    <Page>
      <ContentContainer>
        <Grow />
        <LoginContainer>
          <AuthHeader />
          <SmsInput />
        </LoginContainer>
      </ContentContainer>
    </Page>
  );
};

export default Login;
